package com.rajen.angrejidictionary.pages.word

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.rajen.angrejidictionary.components.layouts.PageLayoutData
import com.rajen.angrejidictionary.components.widgets.WordCard
import com.rajen.angrejidictionary.presentation.viewmodel.WordViewModel
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext

// Route params come straight off the raw URL path segment and are NOT
// guaranteed to be decoded (e.g. "Wall%20niche" stays literal instead of
// becoming "Wall niche"). If we don't decode here, that raw "%20" gets
// re-encoded downstream into "%2520", breaking the API lookup.
// decodeURIComponent on an already-decoded string is a safe no-op.
private fun decodeRouteParam(value: String): String = try {
    js("decodeURIComponent(value)") as String
} catch (e: Throwable) {
    value
}

@InitRoute
fun initWordDetailPage(ctx: InitRouteContext) {
    val term = decodeRouteParam(ctx.route.params["word"].orEmpty())
    val niceTerm = term.replaceFirstChar { it.uppercaseChar() }

    ctx.data.add(
        PageLayoutData(
            title = if (term.isBlank()) "Word" else niceTerm,
            description = if (term.isBlank())
                "Look up any English word with Gujarati meaning and pronunciation."
            else
                "Meaning, pronunciation, usage and grammar for \"$term\" in Gujarati - Angreji Dictionary."
        )
    )
}

@Page("{word}")
@Layout(".components.layouts.PageLayout")
@Composable
fun WordDetailPage() {
    val ctx = rememberPageContext()
    val term = decodeRouteParam(ctx.route.params["word"].orEmpty())

    val viewModel = remember {
        WordViewModel()
    }

    LaunchedEffect(term) {
        viewModel.loadWord(term)
    }

    Box(
        Modifier
            .fillMaxWidth()
            .backgroundColor(Color.rgb(0xFF, 0xEC, 0xDE)),
        contentAlignment = Alignment.Center
    ) {
        WordCard(state = viewModel.uiState)
    }
}